import moment from 'moment'
import config from '../config'

const saleStates = {
  presale: 1,
  sale: 2,
  aftersale: 3,
}

export const appState = {
  hadWeb3: false,
  stats: {
    ether: '...',
    dollar: '...',
    currentBlock: 1000000,
    initialBlock: 1,
    finalBlock: 2,
  },
  saleState: {
    state: saleStates.presale,
    nextImportantTime: new Date(),
    remainingSeconds: -1,
  },
  exchangeRate: 0,
  termsAccepted: false,
  ready: false,
}

const calculateBlockTime = (from, to) => {
  if (from < to) return new Date()

  const t = (from - to - 1) * config.blockTime
  return new Date(+new Date() + (1000 * t))
}

const calculateRemainingSecs = (to) => {
  const time = moment(to)
  const diff = time.diff(moment.now())
  const duration = moment.duration(diff)
  return duration.seconds()
}

const determineSaleState = (state) => {
  if (state.stats.initialBlock === 0 || state.stats.currentBlock === 0) {
    state.saleState.state = saleStates.presale
    return
  }

  if (state.stats.currentBlock < state.stats.initialBlock - 1) {
    state.saleState.state = saleStates.presale
    const t = calculateBlockTime(state.stats.initialBlock, state.stats.currentBlock)
    state.saleState.nextImportantTime = t
    state.saleState.remainingSeconds = calculateRemainingSecs(t)
    return
  }

  if (state.stats.currentBlock > state.stats.finalBlock ||
     (state.stats.ether >= state.stats.cap && state.stats.ether > 0)) {
    state.saleState.state = saleStates.aftersale
    state.saleState.nextImportantTime = null
    return
  }

  state.saleState.state = saleStates.sale
  const t = calculateBlockTime(state.stats.finalBlock, state.stats.currentBlock)
  state.saleState.nextImportantTime = t
  state.saleState.remainingSeconds = calculateRemainingSecs(t)
}

export const mutations = {
  setTotalCollected(state, { ether }) {
    state.stats.ether = parseInt(ether, 10)
    determineSaleState(state)

    state.stats.dollar = parseInt(ether * 90, 10)
  },

  setCurrentBlock(state, { blockNumber }) {
    state.stats.currentBlock = blockNumber
    determineSaleState(state)
  },

  setSaleBlocks(state, { initialBlock, finalBlock }) {
    state.stats.initialBlock = initialBlock
    state.stats.finalBlock = finalBlock
    determineSaleState(state)
    state.ready = true
  },

  setHadWeb3(state, hadWeb3) {
    state.hadWeb3 = hadWeb3
  },

  setCap(state, { cap, revealed }) {
    state.stats.cap = parseInt(cap, 10)
    state.stats.capRevealed = revealed
    determineSaleState(state)
  },

  setTermsAccepted(state, accepted) {
    state.termsAccepted = accepted
  },

  setRemainingSeconds(state, seconds) {
    state.saleState.remainingSeconds = seconds
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js